import { render, staticRenderFns } from "./TermUse.vue?vue&type=template&id=33d98cb5&"
import script from "./TermUse.vue?vue&type=script&lang=js&"
export * from "./TermUse.vue?vue&type=script&lang=js&"
import style0 from "./TermUse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports